import { render, staticRenderFns } from "./RsaPazienteSchedaAachenerAphasieTestListComponent.vue?vue&type=template&id=ca69deb4"
import script from "./RsaPazienteSchedaAachenerAphasieTestListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSchedaAachenerAphasieTestListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports